// Single source of truth for the 14 color/saturation/border knobs the
// composer exposes. Keeping these clustered avoids the prop-drilling and
// default-fallback boilerplate that the original 14 separate useStates
// scattered across share.ts, useFleet, and Composer.tsx.

export interface ColorState {
  hue: number;
  accentHue: number;
  glowHue: number;
  detailHue: number;
  trimHue: number;
  backgroundHue: number;
  primarySat: number;
  accentSat: number;
  glowSat: number;
  detailSat: number;
  trimSat: number;
  bgSat: number;
  borderEnabled: boolean;
  borderColor: string;
}

export const DEFAULT_COLORS: ColorState = {
  hue: 210,
  accentHue: 40,
  glowHue: 180,
  detailHue: 45,
  trimHue: 210,
  backgroundHue: 222,
  primarySat: 100,
  accentSat: 100,
  glowSat: 100,
  detailSat: 100,
  trimSat: 100,
  bgSat: 100,
  borderEnabled: false,
  borderColor: '#000000',
};

export function randomColors(): ColorState {
  const r = () => Math.floor(Math.random() * 360);
  return {
    hue: r(), accentHue: r(), glowHue: r(),
    detailHue: r(), trimHue: r(), backgroundHue: r(),
    primarySat: 100, accentSat: 100, glowSat: 100,
    detailSat: 100, trimSat: 100, bgSat: 100,
    borderEnabled: false, borderColor: '#000000',
  };
}
